import React, { useEffect, useRef, useState } from 'react';
import './App.css';

function App() {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState('100vh');
  const [isFullscreen, setIsFullscreen] = useState(false);
  const lastSentHeight = useRef(0);

  const toggleFullscreen = () => {
    if (window !== window.parent) {
      window.parent.postMessage({ type: 'celtisztazo-fullscreen' }, '*');
      return;
    }
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  // Belső iframe-ből érkező magasság üzenetek kezelése
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.height) {
        setIframeHeight(event.data.height + 'px');
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  // LearnDash-nek küldeni a magasságot (csak ha változott)
  useEffect(() => {
    const sendHeightToParent = () => {
      const height = document.documentElement.scrollHeight;
      if (Math.abs(height - lastSentHeight.current) > 10) {
        lastSentHeight.current = height;
        window.parent.postMessage({ height: height }, '*');
      }
    };

    sendHeightToParent();

    const interval = setInterval(sendHeightToParent, 500);
    window.addEventListener('resize', sendHeightToParent);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', sendHeightToParent);
    };
  }, [iframeHeight]);

  return (
    <div className="App">
      <iframe
        ref={iframeRef}
        src="/celtisztazo.html"
        title="Céltisztázó Mátrix Eszköz"
        style={{
          width: '100%',
          height: iframeHeight,
          border: 'none'
        }}
        id="celtisztazo-iframe"
      />
      <button
        type="button"
        className="fullscreen-btn"
        onClick={toggleFullscreen}
        title={isFullscreen ? 'Kilépés a teljes képernyőből' : 'Teljes képernyő'}
        aria-label={isFullscreen ? 'Kilépés a teljes képernyőből' : 'Teljes képernyő'}
      >
        {isFullscreen ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3" />
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
          </svg>
        )}
      </button>
    </div>
  );
}

export default App;
